import script from "./BenefitsList.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsList.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsList.vue?vue&type=style&index=0&id=032dfe7a&lang=scss"

const __exports__ = script;

export default __exports__